import classNames from 'classnames';
import { useContext } from 'react';
import { Outlet } from 'react-router-dom';

import PageContext from '@/Providers/PageContextProvider/PageContext';
import usePlatform from '@/hooks/use-platform';
import { getBrandingLogoUrl } from '@/shared/utils/logo';
import { layoutClassNames } from '@/utils/consts';

import CustomContent from './CustomContent';
import styles from './index.module.scss';

const AppLayout = () => {
  const { experienceSettings, theme } = useContext(PageContext);
  const { isMobile } = usePlatform();

  if (!experienceSettings) {
    return null;
  }

  const {
    color: { isDarkModeEnabled },
    branding,
  } = experienceSettings;

  const logo = getBrandingLogoUrl({ theme, branding, isDarkModeEnabled });
  const shouldShowLogo = Boolean(logo);

  return (
    <div className={styles.viewBox}>
      <div className={classNames(styles.container, layoutClassNames.pageContainer)}>
        {!isMobile && <CustomContent className={layoutClassNames.customContent} />}
        {
          shouldShowLogo && (
            <div className={styles.logoWrapper}>
              {logo && <img className={styles.logo} alt="logo" src={logo} />}
            </div>
          )
        }
        <main className={classNames(styles.main, layoutClassNames.mainContent)}>
          <Outlet />
          {/*!hideLogtoBranding && (
            <LogtoSignature
              className={classNames(styles.signature, layoutClassNames.signature)}
              theme={theme}
            />
          )*/}
        </main>
      </div>
    </div>
  );
};

export default AppLayout;
